import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./date-range-picker.css"; // Import your CSS
import infoIcon from "../../assets/blue_info_icon.svg";
import { FaCalendar } from "react-icons/fa";

const DateRangePicker = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  const [localStartDate, setLocalStartDate] = useState(startDate);
  const [localEndDate, setLocalEndDate] = useState(endDate);
  const [showStartCalendar, setShowStartCalendar] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const today = new Date();
  const ninetyDaysAgo = new Date(today);
  ninetyDaysAgo.setDate(today.getDate() - 90);

  useEffect(() => {
      if (startDate !== localStartDate || endDate !== localEndDate) {
        setLocalStartDate(startDate);
        setLocalEndDate(endDate);
      }
    
  }, [startDate, endDate]);

  const handleStartDateChange = (date) => {
    if (date && date <= today) {
      setLocalStartDate(date);
      onStartDateChange?.(date);
      setShowStartCalendar(false);

      if (localEndDate && (localEndDate < date || localEndDate > new Date(date.getTime() + 90 * 24 * 60 * 60 * 1000))) {
        setLocalEndDate(null);
        onEndDateChange?.(null);
      }
    }
  };

  const handleEndDateChange = (date) => {
    if (date && date <= today) {
      setLocalEndDate(date);
      onEndDateChange?.(date);
      setShowEndCalendar(false);
    }
  };

  const toggleStartCalendar = () => {
    setShowStartCalendar((prev) => !prev);
    setShowEndCalendar(false);
  };

  const toggleEndCalendar = () => {
    setShowEndCalendar((prev) => !prev);
    setShowStartCalendar(false);
  };

  const formatDate = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${day}/${month}/${year}`;
    }
    return "";
  };

  const calculateMinStartDate = () => {
    // if (localEndDate) {
    //   const ninetyDaysAgo = new Date(localEndDate);
    //   ninetyDaysAgo.setDate(localEndDate.getDate() - 90);
    //   return ninetyDaysAgo;
    // }else if(!localEndDate && !localStartDate){
    //   const ninetyDaysAgo = new Date(today);
    //   ninetyDaysAgo.setDate(today.getDate() - 90);
       return ninetyDaysAgo;
    // }
    // return null;
  };

  const calculatMaxDate = () =>{
    if (localStartDate && !localEndDate) {
      const ninetyDaysBefore = new Date(localStartDate);
      ninetyDaysBefore.setDate(localStartDate.getDate() + 90);
      return ninetyDaysBefore > today;
    }
    return null;
  }

  return (
    <div className="date-range-picker">
      <div className="row">
        {/* From Date */}
        <div className="col-6 margin-gap" style={{width:"fit-content"}}>
          <div className="form-group row">
            <div className="col-3">
              <label aria-label="From date label" style={{ justifyContent: "start",paddingTop: "8px" }} className="removed-padding label-column bold-text">From:</label>
            </div>
            <div className="col-9 d-flex align-items-center">
              <div style={{ position: "relative" }}>
                <DatePicker
                  selected={localStartDate}
                  onChange={handleStartDateChange}
                  maxDate={localEndDate || endDate || today}
                  minDate={calculateMinStartDate()}
                  onClickOutside={() => setShowStartCalendar(false)}
                  placeholderText="dd/mm/yyyy"
                  customInput={
                    <div style={{ display: 'flex', alignItems: 'center',width: '145px' }}>
                      <input
                        type="text"
                        className="form-control text-area"
                        value={formatDate(localStartDate || startDate)}
                        readOnly
                        placeholder="dd/mm/yyyy"
                        onClick={() => setShowStartCalendar(true)}
                      />
                      <button
                        type="button"
                        onClick={toggleStartCalendar}
                        className="calendar-button"
                        aria-label="From date Calendar button"
                      >
                        <FaCalendar />
                      </button>
                    </div>
                  }
                />
              </div>
              <span className="mandatory-asterisk">*</span> {/* Asterisk for From Date */}
            </div>
          </div>
        </div>
  
        {/* To Date */}
        <div className="col-6 margin-gap" style={{width:"fit-content"}}>
          <div className="form-group row">
            <div className="col-3">
              <label aria-label="To date label"  style={{ justifyContent: "end",paddingTop: "8px" }} className="removed-padding label-column bold-text">To:</label>
            </div>
            <div className="col-9 d-flex align-items-center" style={{ paddingLeft: "10px" }}>
              <div style={{ position: "relative"}}>
                <DatePicker
                  selected={localEndDate}
                  onChange={handleEndDateChange}
                  maxDate={today || calculatMaxDate()}
                  minDate={localStartDate || startDate || (!localStartDate ? calculateMinStartDate() : null)}
                  onClickOutside={() => setShowEndCalendar(false)}
                  placeholderText="dd/mm/yyyy"
                  customInput={
                    <div style={{ display: 'flex', alignItems: 'center',width: '145px' }}>
                      <input
                        type="text"
                        className="form-control text-area"
                        value={formatDate(localEndDate || endDate)}
                        readOnly
                        placeholder="dd/mm/yyyy"
                        onClick={() => setShowEndCalendar(true)}
                      />
                      <button
                        type="button"
                        onClick={toggleEndCalendar}
                        className="calendar-button"
                        aria-label="To date Calendar button"
                      >
                        <FaCalendar />
                      </button>
                    </div>
                  }
                />
              </div>
              <span className="mandatory-asterisk">*</span> {/* Asterisk for To Date */}
              <div
                className="info-icon d-flex align-items-center"
                style={{ marginLeft: "5px !important" }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <img src={infoIcon} alt="Info" className="info-icon-image" />
                {showTooltip && (
                  <div className="tooltip-msg tooltip-info-icon">
                    <p>You can search up to 90 days in the past.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateRangePicker;